import PropTypes from 'prop-types';

import WorkshopBarnOrOrgCreationForm from './OrgCreationForm';

export default function BarnCreator({ orgId = '', orgName = '', refetch }) {
  return (
    <div className={`BarnCreator`}>
      <WorkshopBarnOrOrgCreationForm
        fieldHasuraName="name"
        fieldTableName="farm"
        fieldLabel={`Create New Barn for ${orgName}`}
        placeholder="New Barn Name"
        onSuccess={() => {
          refetch();
        }}
        onError={console.error}
        extraVariables={{ organization_id: orgId }}
      />
      <br />
    </div>
  );
}

BarnCreator.propTypes = {
  orgId: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};
